import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, Container } from "react-bootstrap";

const Footer = (props) => {
  const urlParams = new URLSearchParams(window.location.search);
  const mode = urlParams.get("dark");
  if (mode !== null) {
    document.body.classList = "";
    switch (mode) {
      case "true":
        document.body.classList = "dark";
        break;
      case "false":
        document.body.classList = "";
        break;
      default:
        document.body.classList = "";
        break;
    }
  }
  return (
    <>
      <footer className="iq-footer bg-white">
        <Container fluid>
          <Row>
            <Col lg="8">
              <ul className="list-inline mb-0">
                <li className="list-inline-item">
                  <Link to="/dashboard/extrapages/mentions-legales">
                    Mentions Légales
                  </Link>
                </li>{" "}
                <li className="list-inline-item">
                  <Link to="/dashboard/extrapages/cgu">
                    CGU
                  </Link>
                </li>{" "}
                <li className="list-inline-item">
                  <Link to="/dashboard/extrapages/cgv">
                    CGV
                  </Link>
                </li>{" "}
                <li className="list-inline-item">
                  <Link to="/dashboard/extrapages/politique-confidentialite">
                    Politique de Confidentialité
                  </Link>
                </li>{" "}
                <li className="list-inline-item">
                  <Link to="/dashboard/extrapages/politique-cookies">
                    Politique de cookies
                  </Link>
                </li>{" "}
                <li className="list-inline-item">
                  <Link to="/dashboard/extrapages/faq">
                    FAQ
                  </Link>
                </li>
              </ul>
            </Col>
            <Col lg="4" className="d-flex justify-content-end align-items-center">
              <img 
                src={require("../../../../assets/images/ibm-partner-plus.png")} 
                alt="IBM Partner Plus" 
                style={{ height: "30px", marginRight: "15px" }} 
              />
              <span>
                Copyright 2025<Link to="#"> SEEKS </Link> All Rights Reserved.
              </span>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
